<!-- @format -->

@if (imageBadgeName) {
	<picture>
		@if (hasMobileAndDesktopImage) {
			<source
				media="(max-width: 576px)"
				[srcset]="mobileImgBadge" />
		}
		<img
			alt="Product Badge"
			class="img-fluid"
			[src]="imgBadge"
			loading="lazy" />
	</picture>
}
